<oaibox-stats-card
  title="Update Machine Configuration"
  icon="fa-duotone fa-solid fa-gear"
  gradient="secondary"
>
  <form
    class="form p-g"
    [formGroup]="updateMachineForm"
    (ngSubmit)="saveConfiguration()"
  >
    <div>
      <label id="serial-number" class="form-label">Serial Number</label>
      <button
        id="serial-number"
        type="button"
        class="form-control"
        (click)="openMachineSerialNumberUpdate()"
        [disabled]="!isRoot"
      >
        {{ machine.oaiboxSerialNumber }}
        <i class="fa-solid fa-shield-halved"></i>
      </button>
    </div>

    <div class="dropdown">
      <label for="oaibox-type" class="form-label">Machine Type</label>
      <button
        id="oaibox-type"
        type="button"
        class="form-control dropdown-toggle"
        data-bs-toggle="dropdown"
      >
        {{ updateMachineForm.value.oaiboxType ?? "Select type" }}
      </button>

      <ul class="dropdown-menu w-100" role="menu">
        @for (type of AVAILABLE_OAIBOX_TYPES; track type) {
          <li>
            <button
              type="button"
              class="dropdown-item"
              [class.selected]="updateMachineForm.value.oaiboxType === type"
              (click)="updateMachineForm.controls.oaiboxType.patchValue(type)"
            >
              {{ type }}
            </button>
          </li>
        }
      </ul>
    </div>

    @if (updateMachineForm.value.oaiboxType === OaiboxType.LAB_KIT) {
      <div class="dropdown">
        <label for="labKitPlatform" class="form-label">LabKit PC</label>
        <button
          id="labKitPlatform"
          type="button"
          class="form-control dropdown-toggle"
          data-bs-toggle="dropdown"
        >
          {{ updateMachineForm.value.platform ?? "Select platform" }}
        </button>
        <ul class="dropdown-menu w-100" role="menu">
          @for (platform of AVAILABLE_LAB_KIT_PLATFORMS; track platform) {
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="updateMachineForm.value.platform === platform"
                (click)="
                  updateMachineForm.controls.platform.patchValue(platform)
                "
              >
                {{ platform }}
              </button>
            </li>
          }
        </ul>
      </div>

      <div class="dropdown">
        <label for="labKitRanMode" class="form-label">RAN Stack</label>
        <button
          id="labKitRanMode"
          type="button"
          class="form-control dropdown-toggle"
          data-bs-toggle="dropdown"
        >
          {{ updateMachineForm.value.ranMode ?? "Select RAN stack" }}
        </button>
        <ul class="dropdown-menu w-100" role="menu">
          @for (ranMode of AVAILABLE_RAN_MODES; track ranMode) {
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="updateMachineForm.value.ranMode === ranMode"
                (click)="updateMachineForm.controls.ranMode.patchValue(ranMode)"
              >
                {{ ranMode }}
              </button>
            </li>
          }
        </ul>
      </div>
    }

    @if (
      updateMachineForm.value.oaiboxType === OaiboxType.OAIBOX_AI_RAN ||
      updateMachineForm.value.oaiboxType === OaiboxType.OCUDU_KIT
    ) {
      <div class="dropdown">
        <label for="platform" class="form-label">Platform</label>
        <button
          id="platform"
          type="button"
          class="form-control dropdown-toggle"
          data-bs-toggle="dropdown"
        >
          {{ updateMachineForm.value.platform ?? "Select platform" }}
        </button>
        <ul class="dropdown-menu w-100" role="menu">
          @for (platform of AVAILABLE_AIRAN_PLATFORMS; track platform) {
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="updateMachineForm.value.platform === platform"
                (click)="
                  updateMachineForm.controls.platform.patchValue(platform)
                "
              >
                {{ platform }}
              </button>
            </li>
          }
        </ul>
      </div>
    }

    @if (
      updateMachineForm.value.oaiboxType &&
      updateMachineForm.value.oaiboxType !== OaiboxType.OAIBOX_AI_RAN &&
      updateMachineForm.value.oaiboxType !== OaiboxType.OCUDU_KIT
    ) {
      <div class="select-buttons">
        <div class="select-buttons-grid">
          @if (updateMachineForm.value.oaiboxType !== OaiboxType.OAIBOX_CU) {
            <div class="select-buttons-group">
              <label class="select-buttons-label">Fronthaul Type</label>
              <div class="select-buttons-container">
                @for (type of AVAILABLE_FRONTHAUL_TYPES; track type) {
                  <button
                    type="button"
                    class="select-btn"
                    [class.light]="
                      updateMachineForm.value.fronthaulType !== type
                    "
                    (click)="
                      updateMachineForm.controls.fronthaulType.patchValue(type)
                    "
                  >
                    {{ FRONTHAUL_TYPE_CONFIG[type].label }}
                  </button>
                }
              </div>
            </div>
          }

          <div class="select-buttons-group">
            <label class="select-buttons-label">Frequency Range</label>
            <div class="select-buttons-container">
              @for (range of AVAILABLE_FREQUENCY_RANGES; track range) {
                <button
                  type="button"
                  class="select-btn"
                  [class.light]="
                    updateMachineForm.value.frequencyRange !== range
                  "
                  (click)="
                    updateMachineForm.controls.frequencyRange.patchValue(range)
                  "
                >
                  {{ range }}
                </button>
              }
            </div>
          </div>

          <div class="select-buttons-group">
            <label class="select-buttons-label">Duplex Mode</label>
            <div class="select-buttons-container">
              @for (mode of AVAILABLE_DUPLEX_MODES; track mode) {
                <button
                  type="button"
                  class="select-btn"
                  [class.light]="updateMachineForm.value.duplexMode !== mode"
                  (click)="
                    updateMachineForm.controls.duplexMode.patchValue(mode)
                  "
                >
                  {{ mode }}
                </button>
              }
            </div>
          </div>

          <div class="select-buttons-group">
            <label class="select-buttons-label">RF Simulator</label>
            <div class="select-buttons-container">
              <button
                type="button"
                class="select-btn"
                [class.light]="updateMachineForm.value.rfSimulatorEnabled"
                (click)="
                  updateMachineForm.controls.rfSimulatorEnabled.patchValue(
                    false
                  )
                "
              >
                Disabled
              </button>
              <button
                type="button"
                class="select-btn"
                [class.light]="!updateMachineForm.value.rfSimulatorEnabled"
                (click)="
                  updateMachineForm.controls.rfSimulatorEnabled.patchValue(true)
                "
              >
                Enabled
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    @if (
      updateMachineForm.value.oaiboxType === OaiboxType.OAIBOX_AI_RAN ||
      updateMachineForm.value.oaiboxType === OaiboxType.OCUDU_KIT
    ) {
      @let subtypes = updateMachineForm.controls.subtypes;

      <section id="subtypes">
        <header class="form-label">Subtypes</header>

        <div id="subtypes-configuration" [formGroup]="subtypes">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center g-g"
          >
            <div class="d-flex">
              @let cn5g = subtypes.value.cn5g;
              <button
                type="button"
                class="select-btn"
                [class.light]="!cn5g"
                (click)="subtypes.controls.cn5g.patchValue(!cn5g)"
              >
                CN5G
              </button>

              @let flexRic = subtypes.value.flexric;
              <button
                type="button"
                class="select-btn"
                [class.light]="!flexRic"
                (click)="subtypes.controls.flexric.patchValue(!flexRic)"
              >
                FlexRIC
              </button>

              @let xApp = subtypes.value.xApp;
              <button
                type="button"
                class="select-btn"
                [class.light]="!xApp"
                (click)="subtypes.controls.xApp.patchValue(!xApp)"
              >
                xApp
              </button>
            </div>

            <div class="d-flex flex-wrap g-g">
              <div class="stepper-btn">
                @let cus = subtypes.controls.cus;

                <button
                  type="button"
                  (click)="cus.length > 0 && cus.removeAt(cus.length - 1)"
                >
                  <i class="fa-solid fa-minus"></i>
                </button>
                <span class="stepper-btn-label">CU</span>
                <span
                  class="stepper-btn-value"
                  [class.light]="cus.length <= 0"
                  >{{ cus.length }}</span
                >
                <button
                  type="button"
                  (click)="cus.push(createComponentConfig())"
                >
                  <i class="fa-solid fa-plus"></i>
                </button>
              </div>

              <div class="stepper-btn">
                @let cusCP = subtypes.controls.cusCP;

                <button
                  type="button"
                  (click)="cusCP.length > 0 && cusCP.removeAt(cusCP.length - 1)"
                >
                  <i class="fa-solid fa-minus"></i>
                </button>
                <span class="stepper-btn-label">CU-CP</span>
                <span
                  class="stepper-btn-value"
                  [class.light]="cusCP.length <= 0"
                  >{{ cusCP.length }}</span
                >
                <button
                  type="button"
                  (click)="cusCP.push(createComponentConfig())"
                >
                  <i class="fa-solid fa-plus"></i>
                </button>
              </div>

              <div class="stepper-btn">
                @let cusUP = subtypes.controls.cusUP;

                <button
                  type="button"
                  (click)="cusUP.length > 0 && cusUP.removeAt(cusUP.length - 1)"
                >
                  <i class="fa-solid fa-minus"></i>
                </button>
                <span class="stepper-btn-label">CU-UP</span>
                <span
                  class="stepper-btn-value"
                  [class.light]="cusUP.length <= 0"
                  >{{ cusUP.length }}</span
                >
                <button
                  type="button"
                  (click)="cusUP.push(createComponentConfig())"
                >
                  <i class="fa-solid fa-plus"></i>
                </button>
              </div>
            </div>
          </div>

          <div class="d-flex g-g">
            <div class="stepper-btn">
              <button type="button" (click)="removeGnb()">
                <i class="fa-solid fa-minus"></i>
              </button>
              <span class="stepper-btn-label">gNB</span>
              <span
                class="stepper-btn-value"
                [class.light]="subtypes.controls.gnbs.length <= 0"
                >{{ subtypes.controls.gnbs.length }}</span
              >
              <button type="button" (click)="addGnb()">
                <i class="fa-solid fa-plus"></i>
              </button>
            </div>

            <div class="stepper-btn">
              <button type="button" (click)="removeDu()">
                <i class="fa-solid fa-minus"></i>
              </button>
              <span class="stepper-btn-label">DU</span>
              <span
                class="stepper-btn-value"
                [class.light]="subtypes.controls.dus.length <= 0"
                >{{ subtypes.controls.dus.length }}</span
              >
              <button type="button" (click)="addDu()">
                <i class="fa-solid fa-plus"></i>
              </button>
            </div>
          </div>

          @if (
            subtypes.controls.gnbs.length > 0 ||
            subtypes.controls.dus.length > 0 ||
            subtypes.controls.cus.length > 0 ||
            subtypes.controls.cusCP.length > 0 ||
            subtypes.controls.cusUP.length > 0
          ) {
            <oaibox-gnb-instance-config-table
              [gnbs]="subtypes.controls.gnbs"
              [dus]="subtypes.controls.dus"
              [cus]="subtypes.controls.cus"
              [cusCP]="subtypes.controls.cusCP"
              [cusUP]="subtypes.controls.cusUP"
              [tenant]="tenant"
            ></oaibox-gnb-instance-config-table>
          }
        </div>
      </section>
    }

    <footer>
      <section id="ptp-configuration">
        @let ptpConfiguration = updateMachineForm.controls.ptpConfiguration;
        <header>
          <h2>PTP Configuration</h2>
        </header>

        <div class="form" [formGroup]="ptpConfiguration">
          <div>
            <label class="form-label" for="interface-name"
              >Interface Name</label
            >
            <input
              id="interface-name"
              type="text"
              class="form-control"
              [formControl]="ptpConfiguration.controls.interfaceName"
            />
          </div>
          <div class="form-switch">
            <input
              id="ptp-enabled"
              type="checkbox"
              role="switch"
              class="form-check-input"
              [formControl]="ptpConfiguration.controls.enabled"
            />
            <label for="ptp-enabled" class="form-label">{{
              ptpConfiguration.value.enabled ? "Enabled" : "Disabled"
            }}</label>
          </div>
        </div>
      </section>

      <div class="modal-buttons-container">
        <button type="button" class="btn btn-ignore" (click)="cancel()">
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-success"
          [disabled]="updateMachineForm.invalid"
        >
          Save
        </button>
      </div>
    </footer>
  </form>
</oaibox-stats-card>
